import { hookstate, useHookstate } from "@hookstate/core"

const ShowValidationResultState = hookstate(false)
export const useShowValidationResult = () => {

  const showValidationResult = useHookstate(ShowValidationResultState)

  return {
    showValidationResult: showValidationResult.get(),
    setShowValidationResult: showValidationResult.set
  }
}
